import { Box, Button, MenuItem, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

import FormProvider, { RHFSelect, RHFTextField } from 'src/components/hook-form';
import CustomModal from 'src/components/modal/customModal';
import { SMS } from 'src/lib/Enums';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import { useState } from 'react';
import { axiosPostCall } from 'src/services/apisCall';

const parseNumbersInput = (input) => {
  const rawList = Array.isArray(input) ? input : String(input).split(',');

  return [...new Set(rawList.map((item) => String(item).trim()).filter(Boolean))];
};

const schema = Yup.object().shape({
  countryCode: Yup.string().required('Country is required'),
  mobileNumber: Yup.string()
    .required('At least one mobile number is required')
    .test(
      'valid-mobile-numbers',
      'Each mobile number must be 10 digits',
      (value) => {
        const numbers = parseNumbersInput(value);

        return numbers.length > 0 && numbers.every((number) => /^\d{10}$/.test(number));
      }
    ),
});

const AddSmsRealNumber = ({ openModal, handleCloseModal, forceLoad }) => {
  const [canSubmit, setCanSubmit] = useState(true);
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      countryCode: '',
      mobileNumber: '',
    },
  });

  const { handleSubmit, reset } = methods;

  const closeModal = () => {
    reset();
    handleCloseModal();
  };

  const onSubmit = async (data) => {
    setCanSubmit(false);
    try {
      const payload = {
        number: parseNumbersInput(data.mobileNumber).map(
          (number) => `${data.countryCode}${number}`
        ),
      };

      await axiosPostCall('smsAddNumber', payload);

      renderSuccessMessage('Number added successfully');
      closeModal();
      forceLoad(true);
    } catch (error) {
      console.error('Add Gateway [handleSubmit]', error);
      const errorMessage = error?.message;
      renderErrorMessage(errorMessage);
    } finally {
      setCanSubmit(true);
    }
  };

  const description = (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2.5} sx={{ width: '100%' }}>
        <RHFSelect name="countryCode" label="Country">
          {SMS.AllowedCountries.map((country) => (
            <MenuItem key={country.value} value={country.value}>
              {country.label} (+{country.value})
            </MenuItem>
          ))}
        </RHFSelect>

        <RHFTextField
          name="mobileNumber"
          label="Mobile Numbers"
          placeholder="Separate multiple mobile numbers with commas"
        />

        <Box>
          <Typography variant="body2">
            When mock mode is enabled, these numbers can receive real SMS messages.
          </Typography>
        </Box>

        <Stack direction="row" spacing={2}>
          <Button type="submit" variant="contained" sx={{ bgcolor: '#212B36' }} disabled={!canSubmit}>
            {canSubmit ? 'Submit' : 'Adding...'}
          </Button>
          <Button type="button" variant="outlined" color="inherit" onClick={closeModal}>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </FormProvider>
  );

  return (
    openModal && (
      <CustomModal
        open={openModal}
        title="Add SMS Real Number"
        description={description}
        close={closeModal}
        width={480}
      />
    )
  );
};

export default AddSmsRealNumber;
